import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BasePage } from '@ripple/core';
import { WarpEntityServiceCache, WarpEntityLogService, WarpEntityCacheFactoryService } from '@ripple/services';
import { AfterSaveEvent } from '@ripple/ui';
import { CommunityGroup, EntityTypes } from '../../_core/models';

@Component({
  selector: 'sagesse-community-group-details',
  templateUrl: './community-group-details.component.html',
  styleUrls: ['./community-group-details.component.scss']
})
export class CommunityGroupDetailsComponent extends BasePage implements OnInit {

  communityGroup: CommunityGroup;
  communityGroupService: WarpEntityServiceCache<CommunityGroup>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private logService: WarpEntityLogService,
    private serviceFactory: WarpEntityCacheFactoryService
  ) {
    super(logService);
  }

  ngOnInit(): void {
    this.communityGroupService = this.serviceFactory.get(EntityTypes.CommunityGroup) as WarpEntityServiceCache<CommunityGroup>;
    this.route.params.subscribe((params) => {
      const id = parseInt(params.entityId, 10);
      if (isNaN(id)) {
        this.communityGroup = CommunityGroup.empty();
        this.logService.logView(this.logFromUrl(''), this.getLogFormat(''));
      } else {
        this.sub = this.communityGroupService.get(id).subscribe((community) => {
          this.communityGroup = community;
          this.logService.logView(this.logFromUrl(''), this.getLogFormat(''));
        });
      }
    });
  }

  logFromUrl(url: string): number | number[] {
    return -1;
  }

  getLogFormat(url: string) {
    return '';
  }

  back() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }


  afterSave(e: AfterSaveEvent) {
    if (e.action === 'add') this.router.navigate([`../${e.entity.entityId}`], { relativeTo: this.route });
    else if (e.action === 'delete') {
      const queryParams = {};
      queryParams['msg'] = 'Community Group Deleted Successfully!';
      this.router.navigate(['../'], { relativeTo: this.route, queryParams });
    }
  }

}
